import { baseServiceRequest } from "@apis/baseServiceRequest"
import type { IGetTpvTypesParams } from "./types"

export const getTpvTypes = async (params?: IGetTpvTypesParams) => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/sales/tpv_types`,
    params,
  })

  return response.data
}
